export default "__VITE_ASSET__3d8ff703__"